
const ordenesMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos")
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            Orden: item.numero_orden ?? '',
            Fecha: item.fecha_pedido ?? '',
            Subtotal: item.subtotal_iva ?? '',
            Subtotal2: item.subtotal_sin_iva ?? '',
            Descuento: item.descuento ?? '',
            Iva: item.iva ?? '',
            Total: item.total ?? '',
            "Estado orden": item.status_nombre ?? '',
            "Estado Pago": item.estado_nombre ?? '',
        }))

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        }
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        }
    }
}

const ordenesByIdMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos")
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            Orden: item.numero_orden ?? '',
            Fecha: item.fecha_pedido ?? '',
            Subtotal: item.subtotal_iva ?? '',
            Subtotal2: item.subtotal_sin_iva ?? '',
            Descuento: item.descuento ?? '',
            Iva: item.iva ?? '',
            Total: item.total ?? '',
            "Estado orden": item.status_nombre ?? '',
            "Estado Pago": item.estado_nombre ?? '',
        }))

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            orden: dataResponse.data[0],
            url: dataResponse.url
        }
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        }
    }
}

const ordenesPendingSendMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos")
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            Orden: item.numero_orden ?? '',
            Fecha: item.fecha_pedido ?? '',
            Subtotal: item.subtotal_iva ?? '',
            Subtotal2: item.subtotal_sin_iva ?? '',
            Envio: item.envio ?? '',
            Descuento: item.descuento ?? '',
            Iva: item.iva ?? '',
            Total: item.total ?? '',
            "Estado orden": item.status_nombre ?? '',
            "Estado Pago": item.estado_nombre ?? '',
        }))

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        }
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ordenesMapper,
    ordenesByIdMapper,
    ordenesPendingSendMapper
}